import { mapState, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ServiceDropboxSelector from '@/components/Ui/ServiceDropboxSelector'
import ServiceContentsScreenSelectorButton from '@/components/Ui/ServiceContentsScreenSelectorButton'
import ServiceDeliveryTypeSelectorButton from '@/components/Ui/ServiceDeliveryTypeSelectorButton'
import ServiceRssSelectorButton from '@/components/Ui/ServiceRssSelectorButton'
import VideochatSelectorButton from '@/components/Ui/VideoChatSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'
import MultiSelector from "./MultiSelector";

export default {
  name: 'ButtonItem',
  components: {
    FileSelectorButton,
    ServiceDropboxSelector,
    ServiceContentsScreenSelectorButton,
    ServiceDeliveryTypeSelectorButton,
    ServiceRssSelectorButton,
    VideochatSelectorButton,
    MultiSelector,
  },
  props: {
    index: Number
  },
  data () {
    return {
      inited: false,

      // input
      input: {
        uuid: null,
        btnSetting: {
          isDefaultFocusedFlg: 0,
          btnName: null,
          iconFile: null,
          focusedIconFile: null,
          disabledIconFile: null,
          labelText: null,
          btnActionType: '',
          btnActionParameter: {
            screenCode: null,
            webUrl: null,
            localFile: null,
            dropBoxFile: {
              serviceDropboxUuid: null,
              fileType: ''
            },
            launchSpApp: null,
            dataUri: null,
            extraData: [
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
              { k: null, value: null, dataType: null },
            ],
            mimeType: null,
            action: null,
          },
          btnDisplayCondition: 0,
          btnDisplayParameter: {
            deliveryTypes: [],
            serviceRssUUIDs: []
          },
          isEnabled: true,
          badgeUseFlg: 0,
          badgeColor: null,
          badgeText: null,
          badgeDisplayCondition: 0,
          badgeDisplayParameter: {
            deliveryTypes: [],
            serviceRssUUIDs: []
          },
          btnDisplayMode: 0,
          btnDisplayAttributeGroupUuids: []
        }
      },

      // ファイルタイプの選択
      inpFileType: '',
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // model
      layoutModel: state => state.serviceScreenSettingForm.layoutModel,
        // .screenLayout.layoutButton
        // .filter(item => item.uuid === this.input.uuid),

      // form
      serviceId: state => state.serviceScreenSettingForm.serviceId,
      serviceContentsId: state => state.serviceScreenSettingForm.serviceContentsId,
      contentsScreenId: state => state.serviceScreenSettingForm.targetId,
      values: state => state.serviceScreenSettingForm.values,

      // model
      serviceRssModel: state => state.serviceScreenSettingForm.serviceRssModel,
      serviceAttributeTypeModel: status=>status.serviceScreenSettingForm.serviceAttributeTypeModel
    }),

    buttonLayoutType () {
      return this.inited
        ? this.layoutModel.screenLayout.layoutButton
          .find(item => item.uuid === this.input.uuid).btnLayoutType
        : 0
    },
    buttonLayoutTypeLabel () {
      return Utility.getConstantsLabel(['Layout', 'Button', 'LayoutType'], this.buttonLayoutType)
    },

    // list
    buttonEnabledList () {
      return Constants.ScreenSetting.ButtonEnabled
    },
    buttonActionList () {
      return Constants.ServiceContents.ButtonAction
    },
    buttonDisplayModeList() {
      return Constants.ServiceContents.ButtonDisplayMode
    },
    serviceAttributeTypeList() {
      return this.serviceAttributeTypeModel
    },
    fileTypeList () {
      return Constants.File.ContentType
    },
    buttonBadgeUseList () {
      return Constants.ServiceContents.ButtonBadgeUse.sort(Utility.sortByKey('index', true))
    },
    buttonBadgeDIsplayConditionList () {
      return Constants.ServiceContents.ButtonBadgeDIsplayCondition
    },

    // enable
    disableFileSelector () {
      return this.inpFileType === ''
    },

    // validate
    formIsValid () {
      return this.validate('btnSetting.btnName') &&
        this.validate('btnSetting.btnDisplayMode') &&
        Validator.validRadio(this.input.btnSetting.isEnabled)
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        uuid: this.input.uuid,
        btnSetting: {
          isDefaultFocusedFlg: this.input.btnSetting.isDefaultFocusedFlg
            ? 1 : 0,
          btnName: this.input.btnSetting.btnName,
          isEnabled: this.input.btnSetting.isEnabled,
          badgeUseFlg: this.input.btnSetting.badgeUseFlg,
          btnDisplayCondition: this.input.btnSetting.btnDisplayCondition,
          btnDisplayMode:this.input.btnSetting.btnDisplayMode,
          btnDisplayAttributeGroupUuids: this.input.btnSetting.btnDisplayMode === 3 ? this.input.btnSetting.btnDisplayAttributeGroupUuids : []
        }
      }

      // アイコン画像
      if (Validator.validFile(this.input.btnSetting.iconFile)) {
        jsonb.btnSetting.iconFile = this.input.btnSetting.iconFile
      }
      if (Validator.validFile(this.input.btnSetting.focusedIconFile)) {
        jsonb.btnSetting.focusedIconFile = this.input.btnSetting.focusedIconFile
      }
      if (Validator.validFile(this.input.btnSetting.disabledIconFile)) {
        jsonb.btnSetting.disabledIconFile = this.input.btnSetting.disabledIconFile
      }
      // ラベル
      if (Validator.validText(this.input.btnSetting.labelText)) {
        jsonb.btnSetting.labelText = this.input.btnSetting.labelText
      }

      // 選択時動作
      if (Validator.validSelect(this.input.btnSetting.btnActionType)) {
        jsonb.btnSetting.btnActionType = this.input.btnSetting.btnActionType
        jsonb.btnSetting.btnActionParameter = {}
      }
      // 選択時動作 : 画面遷移
      if (jsonb.btnSetting.btnActionType === 0) {
        if (Validator.validText(this.input.btnSetting.btnActionParameter.screenCode)) {
          jsonb.btnSetting.btnActionParameter.screenCode = this.input.btnSetting.btnActionParameter.screenCode
        }
      }
      // 選択時動作 : サイト表示
      if (jsonb.btnSetting.btnActionType === 1) {
        if (Validator.validText(this.input.btnSetting.btnActionParameter.webUrl)) {
          jsonb.btnSetting.btnActionParameter.webUrl = this.input.btnSetting.btnActionParameter.webUrl
        }
      }
      // 選択時動作 : ローカルファイル表示
      if (jsonb.btnSetting.btnActionType === 2) {
        if (Validator.validFile(this.input.btnSetting.btnActionParameter.localFile)) {
          jsonb.btnSetting.btnActionParameter.localFile = this.input.btnSetting.btnActionParameter.localFile
        }
      }
      // 選択時動作 : Dropbox
      if (jsonb.btnSetting.btnActionType === 3) {
        if (Validator.validSelect(this.input.btnSetting.btnActionParameter.dropBoxFile.serviceDropboxUuid) &&
          Validator.validSelect(this.input.btnSetting.btnActionParameter.dropBoxFile.fileType)) {
          jsonb.btnSetting.btnActionParameter.dropBoxFile = this.input.btnSetting.btnActionParameter.dropBoxFile
        }
      }
      // 選択時動作 : アプリ起動
      if (jsonb.btnSetting.btnActionType === 4) {
        if (Validator.validText(this.input.btnSetting.btnActionParameter.launchSpApp)) {
          jsonb.btnSetting.btnActionParameter.launchSpApp = this.input.btnSetting.btnActionParameter.launchSpApp
        }
        if (Validator.validText(this.input.btnSetting.btnActionParameter.dataUri)) {
          jsonb.btnSetting.btnActionParameter.dataUri = this.input.btnSetting.btnActionParameter.dataUri
        }
        if (Validator.validText(this.input.btnSetting.btnActionParameter.mimeType)) {
          jsonb.btnSetting.btnActionParameter.mimeType = this.input.btnSetting.btnActionParameter.mimeType
        }
        if (Validator.validText(this.input.btnSetting.btnActionParameter.action)) {
          jsonb.btnSetting.btnActionParameter.action = this.input.btnSetting.btnActionParameter.action
        }
        const extraData = this.input.btnSetting.btnActionParameter.extraData
          .filter(item => Validator.validText(item.k) &&
            Validator.validText(item.value) &&
            Validator.validText(item.dataType))
          .map(item => {
            return {
              key: item.k,
              value: item.value,
              dataType: item.dataType,
            }
          })
        if (extraData.length) {
          jsonb.btnSetting.btnActionParameter.extraData = extraData
        }
      }
      // 選択時動作 : 一つ前の画面に戻る
      if (jsonb.btnSetting.btnActionType === 5) {
        // jsonb.btnSetting.btnActionParameter.screenCode = null
        delete jsonb.btnSetting.btnActionParameter
      }

      // バッジ設定
      if (this.input.btnSetting.badgeUseFlg === 1) {
        if (Validator.validSelect(this.input.btnSetting.badgeColor)) {
          jsonb.btnSetting.badgeColor = this.input.btnSetting.badgeColor
        }
        if (Validator.validSelect(this.input.btnSetting.badgeText)) {
          jsonb.btnSetting.badgeText = this.input.btnSetting.badgeText
        }

        // バッジ表示条件
        if (Validator.validSelect(this.input.btnSetting.badgeDisplayCondition)) {
          jsonb.btnSetting.badgeDisplayCondition = this.input.btnSetting.badgeDisplayCondition
          jsonb.btnSetting.badgeDisplayParameter = {}
        }
        // バッジ表示条件 : お知らせ
        if (jsonb.btnSetting.badgeDisplayCondition === 0) {
          jsonb.btnSetting.badgeDisplayParameter.deliveryTypes = this.input.btnSetting.badgeDisplayParameter.deliveryTypes
        }
        // バッジ表示条件 : RSS
        if (jsonb.btnSetting.badgeDisplayCondition === 1) {
          jsonb.btnSetting.badgeDisplayParameter.serviceRssUUIDs = this.input.btnSetting.badgeDisplayParameter.serviceRssUUIDs
        }

        // // ボタン表示条件
        // if (Validator.validSelect(this.input.btnSetting.btnDisplayCondition)) {
        //   jsonb.btnSetting.btnDisplayCondition = this.input.btnSetting.btnDisplayCondition
        //   jsonb.btnSetting.btnDisplayParameter = {}
        // }
        // // ボタン表示条件 : お知らせ
        // if (jsonb.btnSetting.btnDisplayCondition === 0) {
        //   jsonb.btnSetting.btnDisplayParameter.deliveryTypes = this.input.btnSetting.btnDisplayParameter.deliveryTypes
        // }
        // // ボタン表示条件 : RSS
        // if (jsonb.btnSetting.btnDisplayCondition === 1) {
        //   jsonb.btnSetting.btnDisplayParameter.serviceRssUUIDs = this.input.btnSetting.btnDisplayParameter.serviceRssUUIDs
        // }
      }

      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'button',
          index: this.index,
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'serviceScreenSettingForm/setValidate',
      setInputValue: 'serviceScreenSettingForm/setInputValue',
    }),

    init () {
      // const d = this.values.screenBtnSettings[this.index];
      // console.log('@@', d.uuid, JSON.stringify(d.btnSetting.badgeDisplayParameter))
      let data = $.extend(true, this.input, this.values.screenBtnSettings[this.index])

      data.btnSetting.btnActionParameter.extraData = data.btnSetting.btnActionParameter.extraData
        .map(item => {
          return {
            k: item.key,
            value: item.value,
            dataType: item.dataType,
          }
        })

      // バッジ設定で設定済のRSS設定が削除されていた場合、入力値から削除する
      // console.log('@@data', data.btnSetting.badgeDisplayParameter.serviceRssUUIDs);
      // console.log('@@serviceRssModel', this.serviceRssModel)
      const fixedRssList = data.btnSetting.badgeDisplayParameter.serviceRssUUIDs
        .filter(uuid => this.serviceRssModel.findIndex(item => item.serviceRssUuid === uuid) !== -1)
      // console.log('@@fixedRssList', fixedRssList)
      data.btnSetting.badgeDisplayParameter.serviceRssUUIDs = fixedRssList

      this.$set(this, 'input', data)
      // console.log(this.input.btnSetting.badgeDisplayParameter.deliveryTypes)
      // console.log(this.input.btnSetting.badgeDisplayParameter.serviceRssUUIDs)

      // console.log('@@', this.input.btnSetting.btnActionParameter.localFile);
      const s = this.input.btnSetting
      if (this.input.btnSetting.btnActionType === 2 &&
        this.input.btnSetting.btnActionParameter.localFile) {
        const type = this.input.btnSetting.btnActionParameter.localFile.contentType.split('/')[0];
        switch (type) {
          case 'image':
            this.inpFileType = 'image';
            break;
          case 'video':
            this.inpFileType = 'video';
            break;
          case 'audio':
            this.inpFileType = 'audio';
            break;
          case 'application':
            this.inpFileType = 'pdf';
            break;
          case 'text':
            this.inpFileType = 'txt';
            break;
        }
      }

      // データの初期化完了
      this.$nextTick(() => {
        this.inited = true
      })
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    changeExtraDataSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    /**
     * Dropbox設定の変更
     */
    changeDropboxValue (props) {
      console.log('changeDropboxValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.value)
    },

    /**
     * 画面の変更
     */
    changeScreenFromSelector (props) {
      console.log('deleteScreenFromSelector', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data.screenCode)
    },
    /**
     * 画面の削除
     */
    deleteScreenFromSelector (props) {
      console.log('deleteScreenFromSelector', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
    },

    /**
     * DeliveryType設定の変更
     */
    changeDeliveryTypeValue (props) {
      this.$set(this.input.btnSetting.badgeDisplayParameter, 'deliveryTypes', props.data)
    },

    /**
     * Rss設定の変更
     */
    changeRssValue (props) {
      // console.log(props)
      this.$set(this.input.btnSetting.badgeDisplayParameter, 'serviceRssUUIDs', props.data)
    },

    validate (key) {
      let data = this.getInputNode(key)
      let value = data.parent[data.key]
      switch (key) {
        case 'btnSetting.btnName':
          return Validator.validText(value)
        case 'btnSetting.btnDisplayMode':
          if (value === 3)
            return Validator.validArray(this.input.btnSetting.btnDisplayAttributeGroupUuids)
          else return true
      }
    },

    setServiceAttributeType(param) {
      const newVal = param.new_val
      const oldVal = param.old_val
      if (!this.input.btnSetting.btnDisplayAttributeGroupUuids.length) {
        this.input.btnSetting.btnDisplayAttributeGroupUuids = newVal
      } else {
        if (oldVal.length)
          this.input.btnSetting.btnDisplayAttributeGroupUuids = this.input.btnSetting.btnDisplayAttributeGroupUuids.filter(
            item => !oldVal.includes(item)
          )
        if (newVal.length)
          this.input.btnSetting.btnDisplayAttributeGroupUuids = [
            ...new Set([
              ...this.input.btnSetting.btnDisplayAttributeGroupUuids,
              ...newVal
            ])
          ]
      }
    }
  }
}
